var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 5.94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1a1 1 0 0 0-1.55-.84L7 3.74 1.55.17a1 1 0 1 0-1.1 1.67l6 3.94a1 1 0 0 0 1.1 0l6-3.93A1 1 0 0 0 14 1z"
  })));
};
export default SvgCaret;